import {useMutation} from "@tanstack/react-query";

import {updateLeadMutationOptions} from "./update-lead.mutation-options";

export function useUpdateLead(leadId: string) {
  return useMutation(updateLeadMutationOptions(leadId));
}
